
import { onBeforeMount, ref, defineComponent } from "vue";
// import phone2 from "@/assets/images/phone2.jpg";
// import instruction1 from "@/assets/images/instruction1.jpg";

import carousel1 from "@/assets/images/carousel6.jpg";
import carousel2 from "@/assets/images/carousel2.jpg";
import carousel3 from "@/assets/images/carousel3.png";
import carousel4 from '@/assets/images/carousel7.jpg';
import * as api from "../api/apt";
interface imgListProp {
  name: string;
  src: string;
  title?: string;
}

const hadelInput = () => {
  const inputVla = ref("");
  return inputVla;
};

export default defineComponent({
  methods: {
    changecolor(item) {
      this.color = item;
    },
    goPage(path, id) {
      this.$router.push({ name: path, params: { id: id } });
      window.scrollTo(0, 0);
    },

    goPage1(path) {
      this.$router.push({ name: path });
      window.scrollTo(0, 0);
    },

    getHeight() {
      this.height = this.height = (window.innerWidth * 2842) / 4997 - 50 + "px";
      console.log(this.height)
    },

    getProductList() {
      api.getProductList().then(res => {
        sessionStorage.setItem("pId", res.data.result.results[0].id);
      });
    },
    openshop(url) {
      window.open(url);
    }
  },

  data() {
    return {
      height: "",
      color: "purple"
    };
  },

  mounted() {
    this.getHeight();
    window.addEventListener("resize", this.getHeight);
    this.getProductList();
  },

  setup() {
    let imgList = ref<imgListProp[] | null>(null);
    const result = hadelInput();
    onBeforeMount(() => {
      imgList.value = [
        {
          name: "v4",
          src: carousel4,
          title: "v4"
        },
        {
          name: "v3",
          src: carousel1,
          title: "v3"
        },
        {
          name: "v1",
          src: carousel3,
          title: "v1"
        },
        {
          name: "v2",
          src: carousel2,
          title: "v2"
        },

      ];
    });
    return { result, imgList };
  }
});
